
define('ldsh!modules/lp_leads/templates/lead_listing', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<thead>\n  <tr>\n    <th data-i18n="landingPage.leadTimestamp">Fecha/Hora</th>\n    <th data-i18n="landingPage.step">Paso</th>\n    ';
 for (var i=0; i < this.columnHeaders.length; ++i) { ;
__p += '\n      <th>' +
((__t = ( this.columnHeaders[i] )) == null ? '' : __t) +
'</th>\n    ';
 } ;
__p += '\n    <th class="ed-table-action-td" data-i18n="integration.see_defaults">Ver sistema</th>\n    <th class="ed-table-action-td" data-i18n="integration.see_integrations">Ver integraciones</th>\n  </tr>\n</thead>\n<tbody class="js-tbody">\n</tbody>\n';

}
return __p
};});

